// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ygSKk","list":"styles_list__IiWUL","listWrapper":"styles_listWrapper__zcBos","box":"styles_box__7dmyL"};